import { router } from '@version/router';
import { store } from '@store';
import { getJWT } from '@version/models/headers-handler';

export const getProperties = (route, properties) => {
  const propertiesMap = {
    token: () => getJWT(),
    sessionId: () => Math.floor(Date.now() / 1000),
    userId: () => store.state.currentUser.id,
    firstname: () => store.state.currentUser.first_name,
    language: () => route.params.locale,
    currentSite: () => route.params.siteId,
    sites: () => store.state.currentUser.sites.map(site => ({ id: site.id, name: site.name })),
  };

  return properties.reduce((result, property) => {
    if (propertiesMap[property]) {
      result[property] = propertiesMap[property]();
    }
    return result;
  }, {});
};

export const navigateTo = (route, message) => {
  const siteId = route.params.siteId;
  const locale = route.params.locale;
  const routeName = message.data?.route;
  const routeOptions = message.data?.options;
  if (routeName) {
    router
      .push({
        name: routeName,
        params: { locale, siteId },
        ...routeOptions,
      })
      .catch(() => {});
  }
};
